// extracted by mini-css-extract-plugin
module.exports =  {"container":"b429494557--container--M8a6T","info":"b429494557--info--GOAiR","icon":"b429494557--icon--bN2Im"};